// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Box,
//   Checkbox,
//   Avatar,
//   Typography,
//   IconButton,
//   Chip,
//   Badge,
//   Divider,
// } from "@mui/material";
// import Slide from "@mui/material/Slide";
// import {
//   Search as SearchIcon,
//   Close as CloseIcon,
//   PersonAdd as PersonAddIcon,
// } from "@mui/icons-material";
// import ChatServices from "../../../services/ChatServices";
// import { addUserLogs } from "../../../services/userLogServices";
// import { toast } from "react-toastify";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// const CreateGroup = ({
//   contacts,
//   openDialog,
//   setOpenDialog,
//   fetchUsersChat,
// }) => {
//   const [selectedContacts, setSelectedContacts] = useState([]); // This stores contact objects
//   const [groupName, setGroupName] = useState("");
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     const updateTheme = () => {
//       const theme = localStorage.getItem("ThemeSwitch");
//       setIsDarkMode(theme === "true");
//     };
//     updateTheme();
//     window.addEventListener("storage", updateTheme);
//     const originalSetItem = localStorage.setItem;
//     localStorage.setItem = function (key, value) {
//       originalSetItem.apply(this, arguments);
//       if (key === "ThemeSwitch") {
//         updateTheme();
//       }
//     };
//     return () => {
//       window.removeEventListener("storage", updateTheme);
//       localStorage.setItem = originalSetItem;
//     };
//   }, []);

//   const onSelect = (contact) => {
//     const isSelected = selectedContacts.some(
//       (c) => c.userId === contact.userId,
//     );
//     if (isSelected) {
//       setSelectedContacts((prev) =>
//         prev.filter((c) => c.userId !== contact.userId),
//       );
//     } else {
//       setSelectedContacts((prev) => [...prev, contact]);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!groupName.trim()) {
//       toast.error("Please enter a group name");
//       return;
//     }

//     if (selectedContacts.length === 0) {
//       // This should work now
//       toast.error("Please select at least one contact");
//       return;
//     }

//     try {
//       const response = await ChatServices.createGroup(
//         groupName,
//         selectedContacts.map((contact) => contact.userId), // Extract userIds
//       );

//       if (response.status === 200) {
//         toast.success("Group created successfully!");
//         handleClose();
//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "createGroup",
//         };

//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       } else {
//         toast.error(response.message || "Failed to create group");
//       }
//     } catch (error) {
//       console.error("Error calling backend API:", error.message);
//       toast.error("Failed to create group");
//     }
//   };

//   const handleClose = () => {
//     setOpenDialog(false);
//     fetchUsersChat();
//     setSelectedContacts([]);
//     setGroupName("");
//     setSearchQuery("");
//   };

//   // Filter contacts based on search query
//   const filteredContacts = contacts.filter(
//     (contact) =>
//       contact.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       contact.email?.toLowerCase().includes(searchQuery.toLowerCase()),
//   );

//   // Avatar colors
//   const avatarColors = [
//     "#FF6B6B",
//     "#4ECDC4",
//     "#45B7D1",
//     "#96CEB4",
//     "#FFEAA7",
//     "#DDA0DD",
//     "#98D8C8",
//     "#F7DC6F",
//   ];

//   const getAvatarColor = (index) => avatarColors[index % avatarColors.length];

//   // Check if Create Group button should be enabled
//   const isCreateButtonEnabled =
//     groupName.trim() !== "" && selectedContacts.length > 0;

//   return (
//     <Dialog
//       open={openDialog}
//       TransitionComponent={Transition}
//       keepMounted
//       onClose={handleClose}
//       fullWidth
//       maxWidth="sm"
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           background: isDarkMode
//             ? "linear-gradient(145deg, #2a2a2a 0%, #1a1a1a 100%)"
//             : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
//           boxShadow: isDarkMode
//             ? "0 20px 60px rgba(0,0,0,0.5)"
//             : "0 20px 60px rgba(0,0,0,0.1)",
//         },
//       }}
//     >
//       {/* Header */}
//       <DialogTitle
//         sx={{
//           p: 3,
//           pb: 2,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           borderBottom: 1,
//           borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <Avatar
//             sx={{
//               bgcolor: isDarkMode ? "#3a3a3a" : "#e3f2fd",
//               color: isDarkMode ? "#fff" : "#1976d2",
//             }}
//           >
//             <PersonAddIcon />
//           </Avatar>
//           <Box>
//             <Typography
//               variant="h6"
//               fontWeight={700}
//               color={isDarkMode ? "#fff" : "#333"}
//             >
//               Create New Group
//             </Typography>
//             <Typography
//               variant="body2"
//               color={isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.6)"}
//             >
//               Add members and give your group a name
//             </Typography>
//           </Box>
//         </Box>
//         <IconButton
//           onClick={handleClose}
//           sx={{
//             color: "#d32f2f", // strong material red
//             backgroundColor: "rgba(211, 47, 47, 0.49)",

//             "&:hover": {
//               backgroundColor: "rgba(211, 47, 47, 0.18)",
//             },

//             borderRadius: "8px",
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//         {/* <IconButton 
//           onClick={handleClose}
//           sx={{ 
//             color: isDarkMode ? 'rgb(248, 77, 77)' : 'rgba(255, 42, 42, 0.71)',
//             '&:hover': {
//               bgcolor: isDarkMode ? 'rgba(245, 90, 90, 0.1)' : 'rgba(212, 94, 94, 0.05)'
//             }
//           }}
//         >
//           <CloseIcon />
//         </IconButton> */}
//       </DialogTitle>

//       <DialogContent sx={{ p: 0 }}>
//         {/* Group Name Input */}
//         <Box sx={{ p: 3, pb: 2 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             size="medium"
//             placeholder="Group Name"
//             value={groupName}
//             onChange={(e) => setGroupName(e.target.value)}
//             InputProps={{
//               sx: {
//                 borderRadius: 2,
//                 bgcolor: isDarkMode
//                   ? "rgba(255,255,255,0.05)"
//                   : "rgba(0,0,0,0.02)",
//                 "& fieldset": {
//                   borderColor: isDarkMode
//                     ? "rgba(255,255,255,0.1)"
//                     : "rgba(0,0,0,0.1)",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: isDarkMode
//                     ? "rgba(255,255,255,0.2)"
//                     : "rgba(0,0,0,0.2)",
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: isDarkMode ? "#90caf9" : "#1976d2",
//                   borderWidth: 2,
//                 },
//               },
//             }}
//             inputProps={{
//               style: {
//                 color: isDarkMode ? "#fff" : "#333",
//                 fontWeight: 500,
//               },
//             }}
//           />
//         </Box>

//         {/* Search Bar */}
//         <Box sx={{ px: 3, pb: 2 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             size="small"
//             placeholder="Search contacts..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <SearchIcon
//                   sx={{
//                     mr: 1,
//                     color: isDarkMode
//                       ? "rgba(255,255,255,0.5)"
//                       : "rgba(0,0,0,0.5)",
//                   }}
//                 />
//               ),
//               sx: {
//                 borderRadius: 2,
//                 bgcolor: isDarkMode
//                   ? "rgba(255,255,255,0.05)"
//                   : "rgba(0,0,0,0.02)",
//                 "& fieldset": {
//                   borderColor: isDarkMode
//                     ? "rgba(255,255,255,0.1)"
//                     : "rgba(0,0,0,0.1)",
//                 },
//               },
//             }}
//             inputProps={{
//               style: {
//                 color: isDarkMode ? "#fff" : "#333",
//               },
//             }}
//           />
//         </Box>

//         {/* Selected Contacts Chips */}
//         {selectedContacts.length > 0 && (
//           <Box sx={{ px: 3, pb: 2 }}>
//             <Typography
//               variant="caption"
//               color={isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)"}
//               sx={{ mb: 1, display: "block" }}
//             >
//               Selected Members ({selectedContacts.length})
//             </Typography>
//             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//               {selectedContacts.map((contact) => (
//                 <Chip
//                   key={contact.userId}
//                   label={contact.name}
//                   onDelete={() => onSelect(contact)}
//                   size="small"
//                   sx={{
//                     bgcolor: isDarkMode
//                       ? "rgba(144, 202, 249, 0.2)"
//                       : "#e3f2fd",
//                     color: isDarkMode ? "#90caf9" : "#1976d2",
//                     fontWeight: 500,
//                     "& .MuiChip-deleteIcon": {
//                       color: isDarkMode
//                         ? "rgba(144, 202, 249, 0.7)"
//                         : "rgba(25, 118, 210, 0.7)",
//                       "&:hover": {
//                         color: isDarkMode ? "#90caf9" : "#1976d2",
//                       },
//                     },
//                   }}
//                 />
//               ))}
//             </Box>
//           </Box>
//         )}

//         <Divider
//           sx={{
//             borderColor: isDarkMode
//               ? "rgba(255,255,255,0.1)"
//               : "rgba(0,0,0,0.1)",
//           }}
//         />

//         {/* Contacts List */}
//         <Box
//           sx={{
//             maxHeight: "350px",
//             overflowY: "auto",
//             p: 2,
//           }}
//         >
//           {filteredContacts.length === 0 ? (
//             <Box
//               sx={{
//                 textAlign: "center",
//                 py: 4,
//                 color: isDarkMode ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
//               }}
//             >
//               <SearchIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
//               <Typography variant="body1" gutterBottom>
//                 No contacts found
//               </Typography>
//               <Typography variant="body2">
//                 {searchQuery
//                   ? "Try a different search term"
//                   : "Add contacts to get started"}
//               </Typography>
//             </Box>
//           ) : (
//             filteredContacts.map((contact, index) => {
//               const isSelected = selectedContacts.some(
//                 (c) => c.userId === contact.userId,
//               );
//               return (
//                 <Box
//                   key={contact._id}
//                   onClick={() => onSelect(contact)}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     p: 2,
//                     mb: 1,
//                     borderRadius: 2,
//                     cursor: "pointer",
//                     transition: "all 0.2s",
//                     bgcolor: isSelected
//                       ? isDarkMode
//                         ? "rgba(144, 202, 249, 0.15)"
//                         : "rgba(25, 118, 210, 0.08)"
//                       : "transparent",
//                     border: `1px solid ${
//                       isSelected
//                         ? isDarkMode
//                           ? "rgba(144, 202, 249, 0.3)"
//                           : "rgba(25, 118, 210, 0.2)"
//                         : isDarkMode
//                           ? "rgba(255,255,255,0.05)"
//                           : "rgba(0,0,0,0.05)"
//                     }`,
//                     "&:hover": {
//                       bgcolor: isSelected
//                         ? isDarkMode
//                           ? "rgba(144, 202, 249, 0.2)"
//                           : "rgba(25, 118, 210, 0.12)"
//                         : isDarkMode
//                           ? "rgba(255,255,255,0.05)"
//                           : "rgba(0,0,0,0.03)",
//                       transform: "translateY(-2px)",
//                       boxShadow: isDarkMode
//                         ? "0 4px 20px rgba(0,0,0,0.3)"
//                         : "0 4px 20px rgba(0,0,0,0.1)",
//                     },
//                   }}
//                 >
//                   <Checkbox
//                     checked={isSelected}
//                     onChange={() => onSelect(contact)}
//                     sx={{
//                       mr: 2,
//                       color: isDarkMode
//                         ? "rgba(255,255,255,0.3)"
//                         : "rgba(0,0,0,0.3)",
//                       "&.Mui-checked": {
//                         color: isDarkMode ? "#90caf9" : "#1976d2",
//                       },
//                     }}
//                   />

//                   <Avatar
//                     sx={{
//                       width: 48,
//                       height: 48,
//                       bgcolor: getAvatarColor(index),
//                       color: "#fff",
//                       fontWeight: 600,
//                       fontSize: "1.2rem",
//                       mr: 2,
//                     }}
//                   >
//                     {contact.name?.charAt(0)?.toUpperCase() || "U"}
//                   </Avatar>

//                   <Box sx={{ flex: 1 }}>
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       color={isDarkMode ? "#fff" : "#333"}
//                       sx={{ mb: 0.5 }}
//                     >
//                       {contact.name || "Unknown User"}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       color={
//                         isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)"
//                       }
//                       sx={{ fontSize: "0.85rem" }}
//                     >
//                       {contact.email || "No email provided"}
//                     </Typography>
//                   </Box>

//                   {isSelected && (
//                     <Chip
//                       label="Selected"
//                       size="small"
//                       sx={{
//                         bgcolor: isDarkMode
//                           ? "rgba(144, 202, 249, 0.2)"
//                           : "#e3f2fd",
//                         color: isDarkMode ? "#90caf9" : "#1976d2",
//                         fontWeight: 500,
//                       }}
//                     />
//                   )}
//                 </Box>
//               );
//             })
//           )}
//         </Box>
//       </DialogContent>

//       {/* Footer Actions */}
//       <DialogActions
//         sx={{
//           p: 3,
//           pt: 2,
//           borderTop: 1,
//           borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             width: "100%",
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Chip
//               icon={<PersonAddIcon sx={{ fontSize: 16 }} />}
//               label={`${selectedContacts.length} selected`}
//               variant="outlined"
//               size="small"
//               sx={{
//                 borderColor: isDarkMode
//                   ? "rgba(255,255,255,0.2)"
//                   : "rgba(0,0,0,0.2)",
//                 color: isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
//               }}
//             />
//             <Chip
//               label={`${filteredContacts.length} total`}
//               variant="outlined"
//               size="small"
//               sx={{
//                 borderColor: isDarkMode
//                   ? "rgba(255,255,255,0.2)"
//                   : "rgba(0,0,0,0.2)",
//                 color: isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
//               }}
//             />
//           </Box>

//           <Box sx={{ display: "flex", gap: 2 }}>
//             <Button
//               onClick={handleClose}
//               variant="outlined"
//               sx={{
//                 borderRadius: 2,
//                 px: 3,
//                 textTransform: "none",
//                 fontWeight: 600,
//                 borderColor: isDarkMode
//                   ? "rgba(255,255,255,0.3)"
//                   : "rgba(0,0,0,0.3)",
//                 color: isDarkMode ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.8)",
//                 "&:hover": {
//                   borderColor: isDarkMode
//                     ? "rgba(255,255,255,0.5)"
//                     : "rgba(0,0,0,0.5)",
//                   bgcolor: isDarkMode
//                     ? "rgba(255,255,255,0.05)"
//                     : "rgba(0,0,0,0.05)",
//                 },
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSubmit}
//               variant="contained"
//               disabled={!isCreateButtonEnabled} // Use the calculated enabled state
//               sx={{
//                 borderRadius: 2,
//                 px: 4,
//                 textTransform: "none",
//                 fontWeight: 600,
//                 bgcolor: isCreateButtonEnabled
//                   ? isDarkMode
//                     ? "#90caf9"
//                     : "#1976d2"
//                   : isDarkMode
//                     ? "rgba(255,255,255,0.1)"
//                     : "rgba(0,0,0,0.1)",
//                 color: isCreateButtonEnabled
//                   ? isDarkMode
//                     ? "#000"
//                     : "#fff"
//                   : isDarkMode
//                     ? "rgba(255,255,255,0.3)"
//                     : "rgba(0,0,0,0.3)",
//                 boxShadow: isCreateButtonEnabled
//                   ? "0 4px 12px rgba(25, 118, 210, 0.3)"
//                   : "none",
//                 "&:hover": isCreateButtonEnabled
//                   ? {
//                       bgcolor: isDarkMode ? "#64b5f6" : "#1565c0",
//                       boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
//                       transform: "translateY(-1px)",
//                     }
//                   : {},
//                 transition: "all 0.2s ease",
//               }}
//             >
//               Create Group
//             </Button>
//           </Box>
//         </Box>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default CreateGroup;


import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Checkbox,
  Avatar,
  Typography,
  IconButton,
  Chip,
  Badge,
  Divider,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import {
  Search as SearchIcon,
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
  Group as GroupIcon,
} from "@mui/icons-material";
import ChatServices from "../../../services/ChatServices";
import { addUserLogs } from "../../../services/userLogServices";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// tourId prop lets the parent (Contacts) pass "chat-tour-create-group" to the trigger button
const CreateGroup = ({
  contacts,
  openDialog,
  setOpenDialog,
  fetchUsersChat,
  triggerButtonId,   // ← NEW: id to put on the trigger element inside this dialog
}) => {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") updateTheme();
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const onSelect = (contact) => {
    const isSelected = selectedContacts.some((c) => c.userId === contact.userId);
    if (isSelected) {
      setSelectedContacts((prev) => prev.filter((c) => c.userId !== contact.userId));
    } else {
      setSelectedContacts((prev) => [...prev, contact]);
    }
  };

  const handleSubmit = async () => {
    if (!groupName.trim()) {
      toast.error("Please enter a group name");
      return;
    }
    if (selectedContacts.length === 0) {
      toast.error("Please select at least one contact");
      return;
    }
    try {
      const response = await ChatServices.createGroup(
        groupName,
        selectedContacts.map((contact) => contact.userId)
      );
      if (response.status === 200) {
        toast.success("Group created successfully!");
        handleClose();
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "createGroup",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) toast.error(addLogs.message);
      } else {
        toast.error(response.message || "Failed to create group");
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
      toast.error("Failed to create group");
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    fetchUsersChat();
    setSelectedContacts([]);
    setGroupName("");
    setSearchQuery("");
  };

  const filteredContacts = contacts.filter(
    (contact) =>
      contact.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      contact.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const avatarColors = ["#FF6B6B","#4ECDC4","#45B7D1","#96CEB4","#FFEAA7","#DDA0DD","#98D8C8","#F7DC6F"];
  const getAvatarColor = (index) => avatarColors[index % avatarColors.length];

  const isCreateButtonEnabled = groupName.trim() !== "" && selectedContacts.length > 0;

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: isDarkMode
            ? "linear-gradient(145deg, #2a2a2a 0%, #1a1a1a 100%)"
            : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
          boxShadow: isDarkMode
            ? "0 20px 60px rgba(0,0,0,0.5)"
            : "0 20px 60px rgba(0,0,0,0.1)",
        },
      }}
    >
      {/* ── Header ── */}
      <DialogTitle
        sx={{
          p: 3, pb: 2,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          borderBottom: 1,
          borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar sx={{ bgcolor: isDarkMode ? "#3a3a3a" : "#e3f2fd", color: isDarkMode ? "#fff" : "#1976d2" }}>
            <PersonAddIcon />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} color={isDarkMode ? "#fff" : "#333"}>
              Create New Group
            </Typography>
            <Typography variant="body2" color={isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.6)"}>
              Add members and give your group a name
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={handleClose}
          sx={{
            color: "#d32f2f",
            backgroundColor: "rgba(211, 47, 47, 0.49)",
            "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.18)" },
            borderRadius: "8px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {/* Group Name Input */}
        <Box sx={{ p: 3, pb: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            size="medium"
            placeholder="Group Name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            InputProps={{
              sx: {
                borderRadius: 2,
                bgcolor: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
                "& fieldset": { borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" },
                "&:hover fieldset": { borderColor: isDarkMode ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)" },
                "&.Mui-focused fieldset": { borderColor: isDarkMode ? "#90caf9" : "#1976d2", borderWidth: 2 },
              },
            }}
            inputProps={{ style: { color: isDarkMode ? "#fff" : "#333", fontWeight: 500 } }}
          />
        </Box>

        {/* Search Bar */}
        <Box sx={{ px: 3, pb: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Search contacts..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ mr: 1, color: isDarkMode ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)" }} />
              ),
              sx: {
                borderRadius: 2,
                bgcolor: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
                "& fieldset": { borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" },
              },
            }}
            inputProps={{ style: { color: isDarkMode ? "#fff" : "#333" } }}
          />
        </Box>

        {/* Selected Chips */}
        {selectedContacts.length > 0 && (
          <Box sx={{ px: 3, pb: 2 }}>
            <Typography variant="caption" color={isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)"} sx={{ mb: 1, display: "block" }}>
              Selected Members ({selectedContacts.length})
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {selectedContacts.map((contact) => (
                <Chip
                  key={contact.userId}
                  label={contact.name}
                  onDelete={() => onSelect(contact)}
                  size="small"
                  sx={{
                    bgcolor: isDarkMode ? "rgba(144, 202, 249, 0.2)" : "#e3f2fd",
                    color: isDarkMode ? "#90caf9" : "#1976d2",
                    fontWeight: 500,
                    "& .MuiChip-deleteIcon": {
                      color: isDarkMode ? "rgba(144, 202, 249, 0.7)" : "rgba(25, 118, 210, 0.7)",
                      "&:hover": { color: isDarkMode ? "#90caf9" : "#1976d2" },
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

        <Divider sx={{ borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" }} />

        {/* Contacts List */}
        <Box sx={{ maxHeight: "350px", overflowY: "auto", p: 2 }}>
          {filteredContacts.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4, color: isDarkMode ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)" }}>
              <SearchIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
              <Typography variant="body1" gutterBottom>No contacts found</Typography>
              <Typography variant="body2">
                {searchQuery ? "Try a different search term" : "Add contacts to get started"}
              </Typography>
            </Box>
          ) : (
            filteredContacts.map((contact, index) => {
              const isSelected = selectedContacts.some((c) => c.userId === contact.userId);
              return (
                <Box
                  key={contact._id}
                  onClick={() => onSelect(contact)}
                  sx={{
                    display: "flex", alignItems: "center", p: 2, mb: 1, borderRadius: 2,
                    cursor: "pointer", transition: "all 0.2s",
                    bgcolor: isSelected
                      ? isDarkMode ? "rgba(144, 202, 249, 0.15)" : "rgba(25, 118, 210, 0.08)"
                      : "transparent",
                    border: `1px solid ${
                      isSelected
                        ? isDarkMode ? "rgba(144, 202, 249, 0.3)" : "rgba(25, 118, 210, 0.2)"
                        : isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"
                    }`,
                    "&:hover": {
                      bgcolor: isSelected
                        ? isDarkMode ? "rgba(144, 202, 249, 0.2)" : "rgba(25, 118, 210, 0.12)"
                        : isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
                      transform: "translateY(-2px)",
                      boxShadow: isDarkMode ? "0 4px 20px rgba(0,0,0,0.3)" : "0 4px 20px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Checkbox
                    checked={isSelected}
                    onChange={() => onSelect(contact)}
                    sx={{
                      mr: 2,
                      color: isDarkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                      "&.Mui-checked": { color: isDarkMode ? "#90caf9" : "#1976d2" },
                    }}
                  />
                  <Avatar sx={{ width: 48, height: 48, bgcolor: getAvatarColor(index), color: "#fff", fontWeight: 600, fontSize: "1.2rem", mr: 2 }}>
                    {contact.name?.charAt(0)?.toUpperCase() || "U"}
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight={600} color={isDarkMode ? "#fff" : "#333"} sx={{ mb: 0.5 }}>
                      {contact.name || "Unknown User"}
                    </Typography>
                    <Typography variant="body2" color={isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)"} sx={{ fontSize: "0.85rem" }}>
                      {contact.email || "No email provided"}
                    </Typography>
                  </Box>
                  {isSelected && (
                    <Chip
                      label="Selected"
                      size="small"
                      sx={{
                        bgcolor: isDarkMode ? "rgba(144, 202, 249, 0.2)" : "#e3f2fd",
                        color: isDarkMode ? "#90caf9" : "#1976d2",
                        fontWeight: 500,
                      }}
                    />
                  )}
                </Box>
              );
            })
          )}
        </Box>
      </DialogContent>

      {/* ── Footer ── */}
      <DialogActions
        sx={{
          p: 3, pt: 2,
          borderTop: 1,
          borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Chip
              icon={<PersonAddIcon sx={{ fontSize: 16 }} />}
              label={`${selectedContacts.length} selected`}
              variant="outlined"
              size="small"
              sx={{
                borderColor: isDarkMode ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)",
                color: isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
              }}
            />
            <Chip
              label={`${filteredContacts.length} total`}
              variant="outlined"
              size="small"
              sx={{
                borderColor: isDarkMode ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)",
                color: isDarkMode ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
              }}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{
                borderRadius: 2, px: 3, textTransform: "none", fontWeight: 600,
                borderColor: isDarkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                color: isDarkMode ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.8)",
                "&:hover": {
                  borderColor: isDarkMode ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
                  bgcolor: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
                },
              }}
            >
              Cancel
            </Button>

            {/* ── TOUR TARGET: Create Group submit button ── */}
            <Button
              id={triggerButtonId}
              onClick={handleSubmit}
              variant="contained"
              disabled={!isCreateButtonEnabled}
              sx={{
                borderRadius: 2, px: 4, textTransform: "none", fontWeight: 600,
                bgcolor: isCreateButtonEnabled
                  ? isDarkMode ? "#90caf9" : "#1976d2"
                  : isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
                color: isCreateButtonEnabled
                  ? isDarkMode ? "#000" : "#fff"
                  : isDarkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                boxShadow: isCreateButtonEnabled ? "0 4px 12px rgba(25, 118, 210, 0.3)" : "none",
                "&:hover": isCreateButtonEnabled
                  ? { bgcolor: isDarkMode ? "#64b5f6" : "#1565c0", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)", transform: "translateY(-1px)" }
                  : {},
                transition: "all 0.2s ease",
              }}
            >
              Create Group
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CreateGroup;